<template>
    <!-- 抽签动画 -->
  <div class="animate-box">
    <div class="animate-content">
      <img src="@/assets/images/lecture/ballot_animate.gif" alt="" class="animate-img" />
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.animate-box {
  background-color: rgba($color: #000000, $alpha: 0.5);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  .animate-content {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .animate-img {
        width: 150px;
    }
  }
}
</style>
